import { ApiError } from '@/api/client'

/**
 * A message a person can act on. Raw exception strings never reach the UI, but
 * the API's own `detail` is written for humans, so it is worth showing.
 */
export function describeError(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return 'The music source is busy. Try again in a moment.'
    if (error.status >= 500) return 'The server had a problem. Try again in a moment.'
    return error.message || fallback
  }
  // fetch() rejects with a TypeError when the request never reached the server.
  if (error instanceof TypeError) return 'Could not reach the server. Check your connection.'
  return fallback
}
